import { makeStyles } from 'tss-react/mui';

export const LIST_BORDER_COLOR = 'rgba(0,0,0,0.1)';
export const LIST_BORDER = '1px solid ' + LIST_BORDER_COLOR;

export const useListRowStyles = makeStyles()(() => ({}));

export const useCustomListRowStyles = makeStyles()(() => ({
  hideMetrics: {
    '& #metrics-cell': { opacity: 0, transition: 'opacity 0.1s ease-out' },
  },
  showMetrics: {
    '& #metrics-cell': { opacity: 1, transition: 'opacity 0.1s ease-in' },
  },
}));
